import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';

const GET_VENDOR_SSN = '/api/manpowers/jobrequirementdetails/{:ID}/vendor-ssn';

/**
 * Bugs 36323 / 36326: the full SSN the MPR dialog's Drug Test and Background vendor links copy. The requirement read
 * returns it masked to most users; this read is gated (Full SSN ReadAll, Background tab view, or a prospect the caller
 * may already read in full) and logged server-side. Keep the value out of personJobRequirements: a save would post it.
 */
@Injectable({ providedIn: 'root' })
export class VendorSsnService {
  private readonly http: HttpClient = inject(
    MyHttpClientFactory
  ).createHttpClient(
    environment.urls?.spartaAPI ?? '',
    true,
    ResponseCasingEnum.PascalCase
  );

  fetchVendorSsn(manpowerReqDetailId: string): Observable<string> {
    return this.http
      .get<{ SSN: string | null }>(
        GET_VENDOR_SSN.split('{:ID}').join(manpowerReqDetailId)
      )
      .pipe(map((r) => r?.SSN ?? ''));
  }
}
